import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';

import { EventsExportFormatsActions } from './eventsExportFormatsActions/EventsExportFormatsActions';
import { EventsExportFormatsTableRowProps } from './EventsExportFormatsTableRow.types';

export const EventsExportFormatsTableRow = ({ row }: EventsExportFormatsTableRowProps) => {
  const { formatMessage } = useLocale();

  const typLabel =
    row.kind === 'SYSTEMOWE'
      ? formatMessage({ id: AppMessages['definitions.events.format.typ.systemowe'] })
      : formatMessage({ id: AppMessages['definitions.events.format.typ.uzytkownika'] });

  return (
    <>
      <Table.RowItem>{row.nazwa}</Table.RowItem>
      <Table.RowItem>{typLabel}</Table.RowItem>
      <Table.RowItem>{row.format}</Table.RowItem>

      <EventsExportFormatsActions row={row} />
    </>
  );
};
